import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { fetchData } from "../../helpers/getData/fetchData"
import { AddOpportunities } from "./AddOpportunities"


export const GetStartupData = () => {

    const { t } = useTranslation('global')
    const [startupList, setStartupList] = useState('isLoading')
    const [vehiclesList, setVehicles] = useState('isLoading')

    useEffect(() => {
        fetchData(setStartupList, '/startups', t);
        fetchData(setVehicles, '/vehicle/nameList', t);
    }, [t])

    return (
        <>
            {
                (startupList !== 'isLoading' && vehiclesList !== 'isLoading') &&
                <AddOpportunities startupList={startupList} vehiclesList={vehiclesList} />
            }
        </>
    )
}
